var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',{attrs:{"title":"Crear Grupo","onClose":_vm.onClose,"isSmall":true,"onConfirm":_vm.onSaveButtonClick,"showSpinnerInConfirmButton":_vm.save.status === 'loading',"confirmLabel":"Guardar"}},[_c('GroupForm',{attrs:{"group":this.model,"showErrors":_vm.showErrors},on:{"errorState":function (state) { this$1.errorFound = state; }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }